(window["webpackJsonp"] = window["webpackJsonp"] || []).push([["main"],{

/***/ "./$$_lazy_route_resource lazy recursive":
/*!******************************************************!*\
  !*** ./$$_lazy_route_resource lazy namespace object ***!
  \******************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

function webpackEmptyAsyncContext(req) {
	// Here Promise.resolve().then() is used instead of new Promise() to prevent
	// uncaught exception popping up in devtools
	return Promise.resolve().then(function() {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	});
}
webpackEmptyAsyncContext.keys = function() { return []; };
webpackEmptyAsyncContext.resolve = webpackEmptyAsyncContext;
module.exports = webpackEmptyAsyncContext;
webpackEmptyAsyncContext.id = "./$$_lazy_route_resource lazy recursive";

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html":
/*!**************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html ***!
  \**************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<app-header></app-header>\n<div class=\"loading\" *ngIf=\"loading\">\n    <mat-progress-bar [color]=\"color\" [mode]=\"mode\" [value]=\"value\"></mat-progress-bar>\n</div>\n\n<router-outlet></router-outlet>\n<app-footer></app-footer>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/home/home.component.html":
/*!*******************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/home/home.component.html ***!
  \*******************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<ng-container>\n    <app-slider></app-slider>\n</ng-container>\n\n<div class=\"listing\">\n    <div class=\"listing__head\">\n        <h3 class=\"listing__title\">Trending Movies</h3>\n        <a [routerLink]=\"['/movies']\" routerLinkActive=\"router-link-active\" class=\"listing__explore\">\n            <strong>Explore All</strong>\n        </a>\n    </div>\n    \n    <app-skeleton *ngIf=\"loader\" ></app-skeleton>\n    <p-carousel [value]=\"nowPlaying\" [numVisible]=\"6\" [numScroll]=\"4\" [circular]=\"false\" *ngIf=\"!loader\"\n        [responsiveOptions]=\"responsiveOptions\">\n        <ng-template let-movie pTemplate=\"item\">\n            <div class=\"listing-item-style\" [routerLink]=\"['/movies/', movie.id]\">\n                <div class=\"overlay\">\n                    <div class=\"hover\"><i class=\"material-icons\">play_arrow</i> PLAY NOW</div>\n                </div>\n                <img *ngIf=\"movie?.poster_path\"\n                    src=\"https://image.tmdb.org/t/p/w370_and_h556_bestv2/{{movie?.poster_path}}\">\n                <img *ngIf=\"!movie?.poster_path\" src=\"assets/images/default-movie.png\">\n                <h6>{{ movie?.title }}</h6>\n                <p class=\"rate\"><i class=\"material-icons\">star</i><span>{{movie?.vote_average}}</span> /10</p>\n                <p class=\"year\"><span>{{movie?.release_date | date: 'yyyy'}}</span>\n                </p>\n            </div>\n        </ng-template>\n    </p-carousel>\n</div>\n\n<div class=\"listing\">\n    <div class=\"listing__head\">\n        <h3 class=\"listing__title\">Trending TV Shows</h3>\n        <a [routerLink]=\"['/tv']\" routerLinkActive=\"router-link-active\" class=\"listing__explore\">\n            <strong>Explore All</strong>\n        </a>\n    </div>\n    <app-skeleton *ngIf=\"loader\"></app-skeleton>\n    <p-carousel [value]=\"tvShows\" [numVisible]=\"6\" [numScroll]=\"4\" [circular]=\"false\" *ngIf=\"!loader\"\n        [responsiveOptions]=\"responsiveOptions\">\n        <ng-template let-tv pTemplate=\"item\">\n            <div class=\"listing-item-style\" [routerLink]=\"['/tv/', tv.id]\">\n                <div class=\"overlay\">\n                    <div class=\"hover\"><i class=\"material-icons\">play_arrow</i> PLAY NOW</div>\n                </div>\n                <img src=\"https://image.tmdb.org/t/p/w370_and_h556_bestv2/{{tv?.poster_path}}\">\n                <h6>{{ tv?.original_name }}</h6>\n                <p class=\"rate\"><i class=\"material-icons\">star</i><span>{{tv?.vote_average}}</span>/10</p>\n                <p class=\"year\"><span>{{tv?.first_air_date | date: 'yyyy'}}</span>\n            </div>\n        </ng-template>\n    </p-carousel>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/includes/footer/footer.component.html":
/*!********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/includes/footer/footer.component.html ***!
  \********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (" <footer class=\"footer\">\n    <div class=\"container-fluid\">\n        <div class=\"row\">\n            <div class=\"col-lg-12 text-center\">\n\n                <!-- <ul class=\"list-inline\">\n                        <li class=\"list-inline-item\">\n                            <a href=\"https://twitter.com/abidakram01\" target=\"_blank\" aria-label=\"Link to Twitter account\">\n                                <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"#585858\"><path d=\"M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z\"></path></svg>\n                            </a>\n                        </li>\n                        <li class=\"list-inline-item\">\n                            <a href=\"https://github.com/abidakram01\" target=\"_blank\" aria-label=\"Link to GitHub account\">\n                                    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"#585858\"><path d=\"M12 0C5.374 0 0 5.373 0 12c0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23A11.509 11.509 0 0 1 12 5.803c1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z\"></path></svg>\n                            </a>\n                        </li>\n                        <li class=\"list-inline-item\">\n                            <a href=\"https://www.linkedin.com/in/abidakram/\" target=\"_blank\" aria-label=\"Link to LinkedIn account\">\n                                    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"#585858\"><path d=\"M19 0H5a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h14a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5zM8 19H5V8h3v11zM6.5 6.732c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zM20 19h-3v-5.604c0-3.368-4-3.113-4 0V19h-3V8h3v1.765c1.396-2.586 7-2.777 7 2.476V19z\"></path></svg>\n                            </a>\n                        </li>\n                        <li class=\"list-inline-item\">\n                            <a href=\"mailto:abid.akram01@gmail.com\" aria-label=\"Link to Email\">\n                                    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\" fill=\"#585858\"><path d=\"M0 3v18h24V3H0zm21.518 2L12 12.713 2.482 5h19.036zM2 19V7.183l10 8.104 10-8.104V19H2z\"></path></svg>\n                            </a>\n                        </li>\n                    </ul>\n<!--                     <p>&copy; 2019 Abid Akram. All rights reserved. </p> -->\n      \n            </div>\n\n        </div>\n    </div>\n</footer>\n");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/includes/header/header.component.html":
/*!********************************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/includes/header/header.component.html ***!
  \********************************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<nav class=\"navbar navbar-expand-lg navbar-light\">\n    <a class=\"navbar-brand\" [routerLink]=\"['/']\">FlixMovies</a>\n    <ul class=\"navbar-nav ml-auto listMenu\">\n        <li class=\"nav-item active\">\n            <a class=\"nav-link\" [routerLink]=\"['/']\" routerLinkActive=\"router-link-active\">Home\n                <span class=\"sr-only\">(current)</span>\n            </a>\n        </li>\n        <li class=\"nav-item\">\n            <a class=\"nav-link\" [routerLink]=\"['/movies']\" routerLinkActive=\"router-link-active\">Movies</a>\n        </li>\n        <li class=\"nav-item\">\n            <a class=\"nav-link\" [routerLink]=\"['/tv']\" routerLinkActive=\"router-link-active\">TV Shows</a>\n        </li>\n        <li class=\"nav-item\">\n            <a class=\"nav-link\" [routerLink]=\"['/genres']\" routerLinkActive=\"router-link-active\">Genres</a>\n        </li>\n    </ul>\n    <span class=\"sidebar-nav-btn\"  pButton icon=\"pi pi-plus\" label=\"Show\" (click)=\"leftSidebar = true\"><img src=\"assets/images/menu.svg\"></span>\n</nav>\n\n<p-sidebar [(visible)]=\"leftSidebar\" position=\"left\" [baseZIndex]=\"10000\">\n    <div class=\"sidebarNav\">\n        <div class=\"menu-container\">\n            <div class=\"sidebarMenu\">\n                <img src=\"assets/images/home.svg\">\n                <a class=\"sidebar-nav-link\" [routerLink]=\"['/']\" routerLinkActive=\"router-link-active\">Home\n                    <span class=\"sr-only\">(current)</span>\n                </a>\n            </div>\n            <div class=\"sidebarMenu\">\n                <img src=\"assets/images/videos.svg\">\n                <a class=\"sidebar-nav-link\" [routerLink]=\"['/movies']\" routerLinkActive=\"router-link-active\">Movies</a>\n            </div>\n            <div class=\"sidebarMenu\">\n                <img src=\"assets/images/tv.svg\">\n                <a class=\"sidebar-nav-link\" [routerLink]=\"['/tv']\" routerLinkActive=\"router-link-active\">TV Shows</a>\n            </div>\n            <div class=\"sidebarMenu genre_\">\n                <img src=\"assets/images/tripod.svg\">\n                <a class=\"sidebar-nav-link\" [routerLink]=\"['/genres']\" routerLinkActive=\"router-link-active\">Genres</a>\n            </div>\n        </div>\n    </div>\n</p-sidebar>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/slider/slider.component.html":
/*!***********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/components/slider/slider.component.html ***!
  \***********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"hero\">\n    <ng-container *ngFor=\"let slider of movies_data; let i = index\">\n        <div class=\"slider\" *ngIf=\"current == i\" @fade>\n            <div class=\"backdrop\">\n                <div class=\"lazyloaded\">\n                    <img alt=\"{{slider?.title}}\" class=\"lazyload image\" src=\"https://image.tmdb.org/t/p/original/{{slider?.backdrop_path}}\">\n                </div>\n            </div>\n            <div class=\"pane\">\n                <div>\n                    <h1 class=\"name\" [routerLink]=\"['/movies/', slider.id]\">\n                        {{slider?.title}}\n                    </h1>\n                    <div class=\"meta\">\n                        <div class=\"info\">\n                            <span class=\"rate\"><i class=\"material-icons\">star</i><span>{{slider?.vote_average}}</span>/10</span>\n                            <span> {{slider?.vote_count | numberWithCommas }} Reviews</span>\n                            <span>{{slider?.release_date | date: 'yyyy' }}</span>\n                        </div>\n                    </div>\n                    <div class=\"desc\">\n                        {{slider?.overview }}\n                    </div>\n                </div>\n            </div>\n        </div>\n    </ng-container>\n</div>");

/***/ }),

/***/ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/skeleton/skeleton.component.html":
/*!***********************************************************************************************!*\
  !*** ./node_modules/raw-loader/dist/cjs.js!./src/app/shared/skeleton/skeleton.component.html ***!
  \***********************************************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("<div class=\"item-with-background\">\n  <ngx-skeleton-loader count=\"5\"\n    [theme]=\"{\n      'border-radius': '5px',\n      height: '20px',\n      'background-color': '#323232',\n      border: '1px solid #323232',\n      'animation-duration': '2s'\n    }\"\n  >\n  </ngx-skeleton-loader>\n</div>");

/***/ }),

/***/ "./node_modules/tslib/tslib.es6.js":
/*!*****************************************!*\
  !*** ./node_modules/tslib/tslib.es6.js ***!
  \*****************************************/
/*! exports provided: __extends, __assign, __rest, __decorate, __param, __metadata, __awaiter, __generator, __exportStar, __values, __read, __spread, __spreadArrays, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__extends", function() { return __extends; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__assign", function() { return __assign; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__rest", function() { return __rest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__decorate", function() { return __decorate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__param", function() { return __param; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__metadata", function() { return __metadata; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__awaiter", function() { return __awaiter; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__generator", function() { return __generator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__exportStar", function() { return __exportStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__values", function() { return __values; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__read", function() { return __read; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spread", function() { return __spread; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__spreadArrays", function() { return __spreadArrays; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__await", function() { return __await; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncGenerator", function() { return __asyncGenerator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncDelegator", function() { return __asyncDelegator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__asyncValues", function() { return __asyncValues; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__makeTemplateObject", function() { return __makeTemplateObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importStar", function() { return __importStar; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__importDefault", function() { return __importDefault; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __exportStar(m, exports) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}


/***/ }),

/***/ "./src/app/app-routing.module.ts":
/*!***************************************!*\
  !*** ./src/app/app-routing.module.ts ***!
  \***************************************/
/*! exports provided: AppRoutingModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppRoutingModule", function() { return AppRoutingModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");
/* harmony import */ var _components_home_home_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/home/home.component */ "./src/app/components/home/home.component.ts");




const routes = [
    {
        path: '',
        component: _components_home_home_component__WEBPACK_IMPORTED_MODULE_3__["HomeComponent"],
    },
    {
        path: 'movies',
        loadChildren: () => Promise.all(/*! import() | components-movies-movies-module */[__webpack_require__.e("default~components-genre-genre-module~components-genre-list-genre-list-module~components-movie-detai~43746966"), __webpack_require__.e("default~components-genre-genre-module~components-genre-list-genre-list-module~components-movie-detai~319376c1"), __webpack_require__.e("default~components-genre-list-genre-list-module~components-movie-details-movie-details-module~compon~fdf253b5"), __webpack_require__.e("components-movies-movies-module")]).then(__webpack_require__.bind(null, /*! ./components/movies/movies.module */ "./src/app/components/movies/movies.module.ts")).then(mod => mod.MoviesModule)
    },
    {
        path: 'movies/:id', loadChildren: () => Promise.all(/*! import() | components-movie-details-movie-details-module */[__webpack_require__.e("default~components-genre-genre-module~components-genre-list-genre-list-module~components-movie-detai~43746966"), __webpack_require__.e("default~components-genre-genre-module~components-genre-list-genre-list-module~components-movie-detai~319376c1"), __webpack_require__.e("default~components-genre-list-genre-list-module~components-movie-details-movie-details-module~compon~848b418d"), __webpack_require__.e("default~components-genre-list-genre-list-module~components-movie-details-movie-details-module~compon~fdf253b5"), __webpack_require__.e("default~components-genre-list-genre-list-module~components-movie-details-movie-details-module~compon~08bc50d6"), __webpack_require__.e("components-movie-details-movie-details-module")]).then(__webpack_require__.bind(null, /*! ./components/movie-details/movie-details.module */ "./src/app/components/movie-details/movie-details.module.ts")).then(mod => mod.MovieDetailsModule)
    },
    {
        path: 'tv',
        loadChildren: () => Promise.all(/*! import() | components-tv-shows-tv-shows-module */[__webpack_require__.e("default~components-genre-genre-module~components-genre-list-genre-list-module~components-movie-detai~43746966"), __webpack_require__.e("default~components-genre-genre-module~components-genre-list-genre-list-module~components-movie-detai~319376c1"), __webpack_require__.e("components-tv-shows-tv-shows-module")]).then(__webpack_require__.bind(null, /*! ./components/tv-shows/tv-shows.module */ "./src/app/components/tv-shows/tv-shows.module.ts")).then(mod => mod.TvShowsModule)
    },
    {
        path: 'tv/:id',
        loadChildren: () => Promise.all(/*! import() | components-tv-show-details-tv-show-details-module */[__webpack_require__.e("default~components-genre-genre-module~components-genre-list-genre-list-module~components-movie-detai~43746966"), __webpack_require__.e("default~components-genre-genre-module~components-genre-list-genre-list-module~components-movie-detai~319376c1"), __webpack_require__.e("default~components-genre-list-genre-list-module~components-movie-details-movie-details-module~compon~848b418d"), __webpack_require__.e("default~components-genre-list-genre-list-module~components-movie-details-movie-details-module~compon~fdf253b5"), __webpack_require__.e("default~components-genre-list-genre-list-module~components-movie-details-movie-details-module~compon~08bc50d6"), __webpack_require__.e("components-tv-show-details-tv-show-details-module")]).then(__webpack_require__.bind(null, /*! ./components/tv-show-details/tv-show-details.module */ "./src/app/components/tv-show-details/tv-show-details.module.ts")).then(mod => mod.TvShowDetailsModule)
    },
    {
        path: 'genres/:id/:name',
        loadChildren: () => Promise.all(/*! import() | components-genre-genre-module */[__webpack_require__.e("default~components-genre-genre-module~components-genre-list-genre-list-module~components-movie-detai~43746966"), __webpack_require__.e("default~components-genre-genre-module~components-genre-list-genre-list-module~components-movie-detai~319376c1"), __webpack_require__.e("components-genre-genre-module")]).then(__webpack_require__.bind(null, /*! ./components/genre/genre.module */ "./src/app/components/genre/genre.module.ts")).then(mod => mod.GenreModule)
    },
    {
        path: 'genres',
        loadChildren: () => Promise.all(/*! import() | components-genre-list-genre-list-module */[__webpack_require__.e("default~components-genre-genre-module~components-genre-list-genre-list-module~components-movie-detai~43746966"), __webpack_require__.e("default~components-genre-genre-module~components-genre-list-genre-list-module~components-movie-detai~319376c1"), __webpack_require__.e("default~components-genre-list-genre-list-module~components-movie-details-movie-details-module~compon~848b418d"), __webpack_require__.e("default~components-genre-list-genre-list-module~components-movie-details-movie-details-module~compon~fdf253b5"), __webpack_require__.e("default~components-genre-list-genre-list-module~components-movie-details-movie-details-module~compon~08bc50d6"), __webpack_require__.e("components-genre-list-genre-list-module")]).then(__webpack_require__.bind(null, /*! ./components/genre-list/genre-list.module */ "./src/app/components/genre-list/genre-list.module.ts")).then(mod => mod.GenreListModule)
    },
    {
        path: 'person/:id',
        loadChildren: () => Promise.all(/*! import() | components-person-person-module */[__webpack_require__.e("default~components-genre-genre-module~components-genre-list-genre-list-module~components-movie-detai~43746966"), __webpack_require__.e("default~components-genre-list-genre-list-module~components-movie-details-movie-details-module~compon~848b418d"), __webpack_require__.e("components-person-person-module")]).then(__webpack_require__.bind(null, /*! ./components/person/person.module */ "./src/app/components/person/person.module.ts")).then(mod => mod.PersonModule)
    },
    {
        path: 'genres-tv/:id/:name',
        loadChildren: () => __webpack_require__.e(/*! import() | components-tv-genre-tv-genre-module */ "components-tv-genre-tv-genre-module").then(__webpack_require__.bind(null, /*! ./components/tv-genre/tv-genre.module */ "./src/app/components/tv-genre/tv-genre.module.ts")).then(m => m.TvGenreModule)
    },
    {
        path: '**',
        redirectTo: ''
    },
];
let AppRoutingModule = class AppRoutingModule {
};
AppRoutingModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"].forRoot(routes)],
        exports: [_angular_router__WEBPACK_IMPORTED_MODULE_2__["RouterModule"]]
    })
], AppRoutingModule);



/***/ }),

/***/ "./src/app/app.component.scss":
/*!************************************!*\
  !*** ./src/app/app.component.scss ***!
  \************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".loading {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n}\n\n.loading .mat-spinner {\n  color: white;\n  position: relative;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92ZXJjZWwvcGF0aDAvc3JjL2FwcC9hcHAuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL2FwcC5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJLGtCQUFBO0VBQ0EsTUFBQTtFQUNBLE9BQUE7RUFDQSxRQUFBO0FDQ0o7O0FERUU7RUFDRSxZQUFBO0VBQ0Esa0JBQUE7RUFDQSxRQUFBO0VBQ0EsU0FBQTtFQUNBLGdDQUFBO0FDQ0oiLCJmaWxlIjoic3JjL2FwcC9hcHAuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyIubG9hZGluZyB7XG4gICAgcG9zaXRpb246IGFic29sdXRlOyBcbiAgICB0b3A6IDA7XG4gICAgbGVmdDogMDtcbiAgICByaWdodDogMDtcbiAgfVxuICBcbiAgLmxvYWRpbmcgLm1hdC1zcGlubmVyIHtcbiAgICBjb2xvcjogd2hpdGU7XG4gICAgcG9zaXRpb246IHJlbGF0aXZlO1xuICAgIHRvcDo1MCU7XG4gICAgbGVmdDogNTAlO1xuICAgIHRyYW5zZm9ybTogdHJhbnNsYXRlKC01MCUsIC01MCUpO1xuICB9XG4iLCIubG9hZGluZyB7XG4gIHBvc2l0aW9uOiBhYnNvbHV0ZTtcbiAgdG9wOiAwO1xuICBsZWZ0OiAwO1xuICByaWdodDogMDtcbn1cblxuLmxvYWRpbmcgLm1hdC1zcGlubmVyIHtcbiAgY29sb3I6IHdoaXRlO1xuICBwb3NpdGlvbjogcmVsYXRpdmU7XG4gIHRvcDogNTAlO1xuICBsZWZ0OiA1MCU7XG4gIHRyYW5zZm9ybTogdHJhbnNsYXRlKC01MCUsIC01MCUpO1xufSJdfQ== */");

/***/ }),

/***/ "./src/app/app.component.ts":
/*!**********************************!*\
  !*** ./src/app/app.component.ts ***!
  \**********************************/
/*! exports provided: AppComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppComponent", function() { return AppComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/router */ "./node_modules/@angular/router/fesm2015/router.js");



let AppComponent = class AppComponent {
    constructor(router) {
        this.router = router;
        this.title = 'FlixMovies';
        this.loading = false;
        this.color = 'warn';
        this.mode = 'indeterminate';
        this.value = 50;
        router.events.subscribe(event => {
            if (event instanceof _angular_router__WEBPACK_IMPORTED_MODULE_2__["NavigationStart"]) {
                this.loading = true;
            }
            else if (event instanceof _angular_router__WEBPACK_IMPORTED_MODULE_2__["NavigationEnd"]) {
                setTimeout(() => {
                    this.loading = false;
                }, 1000);
            }
        });
    }
};
AppComponent.ctorParameters = () => [
    { type: _angular_router__WEBPACK_IMPORTED_MODULE_2__["Router"] }
];
AppComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-root',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./app.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/app.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./app.component.scss */ "./src/app/app.component.scss")).default]
    })
], AppComponent);



/***/ }),

/***/ "./src/app/app.module.ts":
/*!*******************************!*\
  !*** ./src/app/app.module.ts ***!
  \*******************************/
/*! exports provided: AppModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AppModule", function() { return AppModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/platform-browser */ "./node_modules/@angular/platform-browser/fesm2015/platform-browser.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");
/* harmony import */ var _angular_forms__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! @angular/forms */ "./node_modules/@angular/forms/fesm2015/forms.js");
/* harmony import */ var _app_routing_module__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./app-routing.module */ "./src/app/app-routing.module.ts");
/* harmony import */ var _app_component__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./app.component */ "./src/app/app.component.ts");
/* harmony import */ var _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! @angular/platform-browser/animations */ "./node_modules/@angular/platform-browser/fesm2015/animations.js");
/* harmony import */ var primeng_carousel__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! primeng/carousel */ "./node_modules/primeng/fesm2015/primeng-carousel.js");
/* harmony import */ var primeng_sidebar__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! primeng/sidebar */ "./node_modules/primeng/fesm2015/primeng-sidebar.js");
/* harmony import */ var _components_includes_header_header_component__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./components/includes/header/header.component */ "./src/app/components/includes/header/header.component.ts");
/* harmony import */ var _components_slider_slider_component__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./components/slider/slider.component */ "./src/app/components/slider/slider.component.ts");
/* harmony import */ var _components_home_home_component__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./components/home/home.component */ "./src/app/components/home/home.component.ts");
/* harmony import */ var _components_includes_footer_footer_component__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./components/includes/footer/footer.component */ "./src/app/components/includes/footer/footer.component.ts");
/* harmony import */ var _pipe_pipe_module__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./pipe/pipe.module */ "./src/app/pipe/pipe.module.ts");
/* harmony import */ var _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! @angular/material/progress-spinner */ "./node_modules/@angular/material/esm2015/progress-spinner.js");
/* harmony import */ var _angular_material_progress_bar__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! @angular/material/progress-bar */ "./node_modules/@angular/material/esm2015/progress-bar.js");
/* harmony import */ var _shared_skeleton_skeleton_module__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./shared/skeleton/skeleton.module */ "./src/app/shared/skeleton/skeleton.module.ts");


















let AppModule = class AppModule {
};
AppModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["NgModule"])({
        declarations: [
            _app_component__WEBPACK_IMPORTED_MODULE_6__["AppComponent"],
            _components_includes_header_header_component__WEBPACK_IMPORTED_MODULE_10__["HeaderComponent"],
            _components_slider_slider_component__WEBPACK_IMPORTED_MODULE_11__["SliderComponent"],
            _components_home_home_component__WEBPACK_IMPORTED_MODULE_12__["HomeComponent"],
            _components_includes_footer_footer_component__WEBPACK_IMPORTED_MODULE_13__["FooterComponent"],
        ],
        imports: [
            _angular_platform_browser__WEBPACK_IMPORTED_MODULE_1__["BrowserModule"],
            _app_routing_module__WEBPACK_IMPORTED_MODULE_5__["AppRoutingModule"],
            _angular_platform_browser_animations__WEBPACK_IMPORTED_MODULE_7__["BrowserAnimationsModule"],
            _angular_common_http__WEBPACK_IMPORTED_MODULE_3__["HttpClientModule"],
            _angular_forms__WEBPACK_IMPORTED_MODULE_4__["FormsModule"],
            _pipe_pipe_module__WEBPACK_IMPORTED_MODULE_14__["PipeModule"],
            primeng_carousel__WEBPACK_IMPORTED_MODULE_8__["CarouselModule"],
            primeng_sidebar__WEBPACK_IMPORTED_MODULE_9__["SidebarModule"],
            _angular_material_progress_spinner__WEBPACK_IMPORTED_MODULE_15__["MatProgressSpinnerModule"],
            _angular_material_progress_bar__WEBPACK_IMPORTED_MODULE_16__["MatProgressBarModule"],
            _shared_skeleton_skeleton_module__WEBPACK_IMPORTED_MODULE_17__["SkeletonModule"]
        ],
        bootstrap: [_app_component__WEBPACK_IMPORTED_MODULE_6__["AppComponent"]]
    })
], AppModule);



/***/ }),

/***/ "./src/app/components/home/home.component.scss":
/*!*****************************************************!*\
  !*** ./src/app/components/home/home.component.scss ***!
  \*****************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ("\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IiIsImZpbGUiOiJzcmMvYXBwL2NvbXBvbmVudHMvaG9tZS9ob21lLmNvbXBvbmVudC5zY3NzIn0= */");

/***/ }),

/***/ "./src/app/components/home/home.component.ts":
/*!***************************************************!*\
  !*** ./src/app/components/home/home.component.ts ***!
  \***************************************************/
/*! exports provided: HomeComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HomeComponent", function() { return HomeComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var src_app_service_movies_service__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! src/app/service/movies.service */ "./src/app/service/movies.service.ts");
/* harmony import */ var src_app_service_tv_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/service/tv.service */ "./src/app/service/tv.service.ts");
/* harmony import */ var rxjs_internal_operators_delay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/internal/operators/delay */ "./node_modules/rxjs/internal/operators/delay.js");
/* harmony import */ var rxjs_internal_operators_delay__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(rxjs_internal_operators_delay__WEBPACK_IMPORTED_MODULE_4__);





let HomeComponent = class HomeComponent {
    constructor(movies, tv) {
        this.movies = movies;
        this.tv = tv;
        this.loader = true;
        this.responsiveOptions = [
            {
                breakpoint: '1024px',
                numVisible: 3,
                numScroll: 3
            },
            {
                breakpoint: '768px',
                numVisible: 2,
                numScroll: 2
            },
            {
                breakpoint: '560px',
                numVisible: 1,
                numScroll: 1
            }
        ];
    }
    ngOnInit() {
        this.trendingMovies(1);
        this.tvShow(1);
    }
    trendingMovies(page) {
        this.movies.getNowPlaying(page).pipe(Object(rxjs_internal_operators_delay__WEBPACK_IMPORTED_MODULE_4__["delay"])(2000)).subscribe((res) => {
            this.nowPlaying = res.results;
            this.loader = false;
        });
    }
    tvShow(page) {
        this.tv.getTvOnTheAir(page).pipe(Object(rxjs_internal_operators_delay__WEBPACK_IMPORTED_MODULE_4__["delay"])(2000)).subscribe((res) => {
            this.tvShows = res.results;
            this.loader = false;
        });
    }
};
HomeComponent.ctorParameters = () => [
    { type: src_app_service_movies_service__WEBPACK_IMPORTED_MODULE_2__["MoviesService"] },
    { type: src_app_service_tv_service__WEBPACK_IMPORTED_MODULE_3__["TvService"] }
];
HomeComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-home',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./home.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/home/home.component.html")).default,
        encapsulation: _angular_core__WEBPACK_IMPORTED_MODULE_1__["ViewEncapsulation"].None,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./home.component.scss */ "./src/app/components/home/home.component.scss")).default]
    })
], HomeComponent);



/***/ }),

/***/ "./src/app/components/includes/footer/footer.component.scss":
/*!******************************************************************!*\
  !*** ./src/app/components/includes/footer/footer.component.scss ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".footer {\n  background-color: #212121;\n  padding: 1rem 0rem 1rem;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n.footer p {\n  margin-bottom: 5px;\n  font-size: 15px;\n  line-height: 1;\n}\n.footer .list-inline li a {\n  width: 4rem;\n  height: 3rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.footer .list-inline li a svg {\n  transition: all 0.3s ease-in-out;\n}\n.footer .list-inline li a svg:hover {\n  fill: #fff;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92ZXJjZWwvcGF0aDAvc3JjL2FwcC9jb21wb25lbnRzL2luY2x1ZGVzL2Zvb3Rlci9mb290ZXIuY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL2NvbXBvbmVudHMvaW5jbHVkZXMvZm9vdGVyL2Zvb3Rlci5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNFLHlCQUFBO0VBQ0EsdUJBQUE7RUFDQSw4Q0FBQTtBQ0NGO0FEQUU7RUFDRSxrQkFBQTtFQUNBLGVBQUE7RUFDQSxjQUFBO0FDRUo7QURHTTtFQUNFLFdBQUE7RUFDQSxZQUFBO0VBQ0EsYUFBQTtFQUNBLG1CQUFBO0VBQ0EsdUJBQUE7QUNEUjtBREdRO0VBQ0UsZ0NBQUE7QUNEVjtBREdVO0VBQ0UsVUFBQTtBQ0RaIiwiZmlsZSI6InNyYy9hcHAvY29tcG9uZW50cy9pbmNsdWRlcy9mb290ZXIvZm9vdGVyLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLmZvb3RlciB7XG4gIGJhY2tncm91bmQtY29sb3I6ICMyMTIxMjE7XG4gIHBhZGRpbmc6IDFyZW0gMHJlbSAxcmVtO1xuICBib3JkZXItdG9wOiAxcHggc29saWQgcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjEpO1xuICBwIHtcbiAgICBtYXJnaW4tYm90dG9tOiA1cHg7XG4gICAgZm9udC1zaXplOiAxNXB4O1xuICAgIGxpbmUtaGVpZ2h0OiAxO1xuICB9XG5cbiAgLmxpc3QtaW5saW5lIHtcbiAgICBsaSB7XG4gICAgICBhIHtcbiAgICAgICAgd2lkdGg6IDRyZW07XG4gICAgICAgIGhlaWdodDogM3JlbTtcbiAgICAgICAgZGlzcGxheTogZmxleDtcbiAgICAgICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICAgICAganVzdGlmeS1jb250ZW50OiBjZW50ZXI7XG5cbiAgICAgICAgc3ZnIHtcbiAgICAgICAgICB0cmFuc2l0aW9uOiBhbGwgLjNzIGVhc2UtaW4tb3V0O1xuXG4gICAgICAgICAgJjpob3ZlciB7XG4gICAgICAgICAgICBmaWxsOiAjZmZmO1xuICAgICAgICAgIH1cbiAgICAgICAgfVxuICAgICAgfVxuICAgIH1cbiAgfVxufVxuIiwiLmZvb3RlciB7XG4gIGJhY2tncm91bmQtY29sb3I6ICMyMTIxMjE7XG4gIHBhZGRpbmc6IDFyZW0gMHJlbSAxcmVtO1xuICBib3JkZXItdG9wOiAxcHggc29saWQgcmdiYSgyNTUsIDI1NSwgMjU1LCAwLjEpO1xufVxuLmZvb3RlciBwIHtcbiAgbWFyZ2luLWJvdHRvbTogNXB4O1xuICBmb250LXNpemU6IDE1cHg7XG4gIGxpbmUtaGVpZ2h0OiAxO1xufVxuLmZvb3RlciAubGlzdC1pbmxpbmUgbGkgYSB7XG4gIHdpZHRoOiA0cmVtO1xuICBoZWlnaHQ6IDNyZW07XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGFsaWduLWl0ZW1zOiBjZW50ZXI7XG4gIGp1c3RpZnktY29udGVudDogY2VudGVyO1xufVxuLmZvb3RlciAubGlzdC1pbmxpbmUgbGkgYSBzdmcge1xuICB0cmFuc2l0aW9uOiBhbGwgMC4zcyBlYXNlLWluLW91dDtcbn1cbi5mb290ZXIgLmxpc3QtaW5saW5lIGxpIGEgc3ZnOmhvdmVyIHtcbiAgZmlsbDogI2ZmZjtcbn0iXX0= */");

/***/ }),

/***/ "./src/app/components/includes/footer/footer.component.ts":
/*!****************************************************************!*\
  !*** ./src/app/components/includes/footer/footer.component.ts ***!
  \****************************************************************/
/*! exports provided: FooterComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FooterComponent", function() { return FooterComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let FooterComponent = class FooterComponent {
    constructor() { }
    ngOnInit() {
    }
};
FooterComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-footer',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./footer.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/includes/footer/footer.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./footer.component.scss */ "./src/app/components/includes/footer/footer.component.scss")).default]
    })
], FooterComponent);



/***/ }),

/***/ "./src/app/components/includes/header/header.component.scss":
/*!******************************************************************!*\
  !*** ./src/app/components/includes/header/header.component.scss ***!
  \******************************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".navbar {\n  height: 65px;\n  background-color: #212121;\n  padding: 0 47px;\n  margin: 0 auto;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n.navbar .navbar-brand {\n  color: #fff !important;\n  margin-right: 2rem;\n  font-size: 24px;\n}\n.navbar .navbar-nav .nav-item {\n  margin-right: 10px;\n}\n.navbar .navbar-nav .nav-link {\n  color: #fff !important;\n  font-size: 17px;\n  font-weight: 700;\n}\n@media (max-width: 640px) {\n  .navbar .listMenu {\n    display: none;\n  }\n}\n.navbar .search-icon {\n  background-image: url('Search.svg');\n  background-repeat: no-repeat;\n  background-size: 100%;\n  width: 25px;\n  height: 25px;\n  display: inline-block;\n  vertical-align: middle;\n}\n@media (max-width: 640px) {\n  .navbar {\n    height: auto;\n    padding: 0 15px;\n  }\n}\n.sidebar-nav-btn {\n  display: none;\n}\n@media (max-width: 640px) {\n  .sidebar-nav-btn {\n    display: block;\n    width: 35px;\n    height: 35px;\n    margin-left: 10px;\n  }\n}\n.sidebarNav {\n  display: flex;\n  align-items: center;\n  height: 100%;\n}\n.sidebarNav .menu-container {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-height: calc(100% - 60px);\n  width: 100%;\n}\n.sidebarNav .sidebarMenu {\n  margin: 10px 0;\n  position: relative;\n}\n.sidebarNav .sidebarMenu a {\n  font-size: 2rem;\n  letter-spacing: 0.4px;\n  color: #fff !important;\n  margin-left: 40px;\n}\n.sidebarNav .sidebarMenu img {\n  height: 25px;\n  width: 25px;\n  position: absolute;\n}\n.form {\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  z-index: 10;\n}\n.form input[type=text] {\n  flex: 1;\n  height: 6rem;\n  padding: 2.1rem 1.5rem;\n  font-size: 1.6rem;\n  color: #fff;\n  background: none;\n  border: 0;\n  outline: 0;\n}\n@media (min-width: 1200px) {\n  .form input[type=text] {\n    height: 8rem;\n    padding: 3.1rem 5rem;\n  }\n}\n.form button {\n  display: flex;\n  align-items: center;\n  padding: 0 1.5rem;\n  background: none;\n}\n@media (min-width: 1200px) {\n  .form button {\n    padding: 0 5rem;\n  }\n}\n.field {\n  display: flex;\n  background-color: #202124;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/includes/header/header.component.ts":
/*!****************************************************************!*\
  !*** ./src/app/components/includes/header/header.component.ts ***!
  \****************************************************************/
/*! exports provided: HeaderComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderComponent", function() { return HeaderComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let HeaderComponent = class HeaderComponent {
    constructor() { }
    ngOnInit() {
    }
};
HeaderComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-header',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./header.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/includes/header/header.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./header.component.scss */ "./src/app/components/includes/header/header.component.scss")).default]
    })
], HeaderComponent);



/***/ }),

/***/ "./src/app/components/slider/slider.component.scss":
/*!*********************************************************!*\
  !*** ./src/app/components/slider/slider.component.scss ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".hero {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 35rem;\n  color: #999;\n  background-color: #000;\n  position: relative;\n}\n@media (min-width: 640px) {\n  .hero {\n    height: 50rem;\n    position: relative;\n  }\n}\n@media (min-width: 1024px) {\n  .hero {\n    position: relative;\n    display: block;\n    height: 0;\n    padding-bottom: 40%;\n  }\n}\n.slider {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n@media (min-width: 640px) {\n  .slider .slider {\n    position: relative !important;\n  }\n}\n.backdrop {\n  position: relative;\n  display: flex;\n  flex: 1 1 auto;\n  min-height: 0;\n}\n@media (min-width: 1024px) {\n  .backdrop {\n    position: absolute;\n    top: 0;\n    right: 0;\n    display: block;\n    width: 71.1%;\n    height: 100%;\n  }\n}\n.backdrop::after {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  display: block;\n  content: \"\";\n  background-image: linear-gradient(to top, black 0%, rgba(0, 0, 0, 0.1) 50%, rgba(0, 0, 0, 0.1) 100%);\n}\n@media (min-width: 1024px) {\n  .backdrop::after {\n    background-image: linear-gradient(to right, #000 0, transparent 50%, transparent 100%);\n  }\n}\n.backdrop > div {\n  width: 100%;\n}\n@media (min-width: 1024px) {\n  .backdrop > div {\n    display: inline;\n  }\n}\n.play {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  z-index: 1;\n  padding: 0;\n  margin: 0;\n  background: none;\n  transform: translate(-50%, -50%);\n}\n@media (min-width: 1024px) {\n  .play {\n    display: none;\n  }\n}\n.image {\n  display: inline-block;\n  max-width: none;\n  height: 100%;\n}\n@media (max-width: 1023px) {\n  .image {\n    width: 100%;\n    -o-object-fit: cover;\n       object-fit: cover;\n  }\n}\n.pane {\n  padding: 0 1.5rem 1.5rem;\n}\n@media (min-width: 768px) {\n  .pane {\n    padding: 0 4rem 4rem;\n  }\n}\n@media (min-width: 1024px) {\n  .pane {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    display: flex;\n    align-items: center;\n    width: 55%;\n    height: 100%;\n  }\n}\n@media (min-width: 1200px) {\n  .pane {\n    padding-right: 5rem;\n    padding-left: 5rem;\n  }\n}\n@media (min-width: 1400px) {\n  .pane {\n    width: 45%;\n  }\n}\n.name {\n  margin: 0 0 1.4rem;\n  font-size: 2.8rem;\n  line-height: 1.1;\n  color: #fff;\n  letter-spacing: 0.4px;\n  cursor: pointer;\n}\n@media (min-width: 768px) {\n  .name {\n    margin-bottom: 1.8rem;\n  }\n}\n@media (min-width: 1200px) {\n  .name {\n    font-size: 2.4vw;\n  }\n}\n.name:focus {\n  outline: none;\n}\n.meta {\n  font-size: 1.4rem;\n}\n@media (min-width: 768px) {\n  .meta {\n    display: flex;\n  }\n}\n@media (min-width: 1650px) {\n  .meta {\n    font-size: 0.9vw;\n  }\n}\n.rating {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1.3rem;\n}\n@media (min-width: 768px) {\n  .rating {\n    margin: 0 1.2rem 0 0;\n  }\n}\n.info {\n  display: flex;\n  align-items: center;\n}\n.info span {\n  margin-right: 0.4rem;\n}\n.info span:not(:last-child):after {\n  content: \"|\";\n  margin-right: 9px;\n  margin-left: 9px;\n}\n.desc {\n  display: block;\n  margin-top: 2.5rem;\n  font-size: 1.5rem;\n  color: #fff;\n  font-weight: 400;\n  color: #fff;\n  font-family: Dosis, sans-serif;\n}\n@media (max-width: 767px) {\n  .desc {\n    display: none;\n  }\n}\n@media (min-width: 1650px) {\n  .desc {\n    font-size: 0.9vw;\n  }\n}\n.trailer {\n  margin-top: 3rem;\n}\n@media (max-width: 1023px) {\n  .trailer {\n    display: none;\n  }\n}\n@media (min-width: 1650px) {\n  .trailer {\n    font-size: 0.9vw;\n  }\n}\n.rate {\n  font-size: 12px;\n}\n.rate i {\n  font-size: 16px;\n  margin-right: 5px;\n}\n.rate .material-icons {\n  color: #dcf836;\n}\n.rate span {\n  color: #fff;\n  font-size: 16px;\n  font-weight: 400;\n}\n/*# sourceMappingURL=data:application/json;base64,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 */");

/***/ }),

/***/ "./src/app/components/slider/slider.component.ts":
/*!*******************************************************!*\
  !*** ./src/app/components/slider/slider.component.ts ***!
  \*******************************************************/
/*! exports provided: SliderComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SliderComponent", function() { return SliderComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_animations__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/animations */ "./node_modules/@angular/animations/fesm2015/animations.js");
/* harmony import */ var src_app_service_movies_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! src/app/service/movies.service */ "./src/app/service/movies.service.ts");
/* harmony import */ var rxjs_internal_operators_delay__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! rxjs/internal/operators/delay */ "./node_modules/rxjs/internal/operators/delay.js");
/* harmony import */ var rxjs_internal_operators_delay__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(rxjs_internal_operators_delay__WEBPACK_IMPORTED_MODULE_4__);





let SliderComponent = class SliderComponent {
    constructor(movieService) {
        this.movieService = movieService;
        this.current = 0;
    }
    ngOnInit() {
        this.getnowPlayingMovies(1);
        this.sliderTimer();
    }
    getnowPlayingMovies(page) {
        this.movieService.getNowPlaying(page).pipe(Object(rxjs_internal_operators_delay__WEBPACK_IMPORTED_MODULE_4__["delay"])(2000)).subscribe((res) => {
            this.movies_data = res.results;
        });
    }
    sliderTimer() {
        setInterval(() => {
            this.current = ++this.current % this.movies_data.length;
        }, 5000);
    }
};
SliderComponent.ctorParameters = () => [
    { type: src_app_service_movies_service__WEBPACK_IMPORTED_MODULE_3__["MoviesService"] }
];
SliderComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-slider',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./slider.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/components/slider/slider.component.html")).default,
        animations: [
            Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["trigger"])('fade', [
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["transition"])('void => *', [Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["style"])({ opacity: 0 }), Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["animate"])('300ms', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["style"])({ opacity: 1 }))]),
                Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["transition"])('* => void', [Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["style"])({ opacity: 1 }), Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["animate"])('300ms', Object(_angular_animations__WEBPACK_IMPORTED_MODULE_2__["style"])({ opacity: 0 }))]),
            ])
        ],
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./slider.component.scss */ "./src/app/components/slider/slider.component.scss")).default]
    })
], SliderComponent);



/***/ }),

/***/ "./src/app/pipe/character-with-commas.pipe.ts":
/*!****************************************************!*\
  !*** ./src/app/pipe/character-with-commas.pipe.ts ***!
  \****************************************************/
/*! exports provided: CharacterWithCommasPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CharacterWithCommasPipe", function() { return CharacterWithCommasPipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let CharacterWithCommasPipe = class CharacterWithCommasPipe {
    transform(array) {
        if (array) {
            return array.map(item => item.name).join(', ');
        }
    }
};
CharacterWithCommasPipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'characterWithCommas'
    })
], CharacterWithCommasPipe);



/***/ }),

/***/ "./src/app/pipe/date.pipe.ts":
/*!***********************************!*\
  !*** ./src/app/pipe/date.pipe.ts ***!
  \***********************************/
/*! exports provided: DatePipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DatePipe", function() { return DatePipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let DatePipe = class DatePipe {
    transform(value) {
        if (value) {
            const dateArray = value.split('-');
            const date = dateArray[2].substr(0, 1) === '0' ? dateArray[2].substr(1, 1) : dateArray[2];
            const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            return `${date} ${months[dateArray[1] - 1]} ${dateArray[0]}`;
        }
    }
};
DatePipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'fullDate'
    })
], DatePipe);



/***/ }),

/***/ "./src/app/pipe/elipsis.pipe.ts":
/*!**************************************!*\
  !*** ./src/app/pipe/elipsis.pipe.ts ***!
  \**************************************/
/*! exports provided: ElipsisPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElipsisPipe", function() { return ElipsisPipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let ElipsisPipe = class ElipsisPipe {
    transform(text, length, clamp) {
        text = text || '';
        clamp = clamp || '...';
        length = length || 30;
        if (text.length <= length)
            return text;
        let tcText = text.slice(0, length - clamp.length);
        let last = tcText.length - 1;
        while (last > 0 && tcText[last] !== ' ' && tcText[last] !== clamp[0])
            last -= 1;
        // Fix for case when text dont have any `space`
        last = last || length - clamp.length;
        tcText = tcText.slice(0, last);
        return tcText + clamp;
    }
};
ElipsisPipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'elipsis'
    })
], ElipsisPipe);



/***/ }),

/***/ "./src/app/pipe/full-language.pipe.ts":
/*!********************************************!*\
  !*** ./src/app/pipe/full-language.pipe.ts ***!
  \********************************************/
/*! exports provided: FullLanguagePipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FullLanguagePipe", function() { return FullLanguagePipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _service_language__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../service/language */ "./src/app/service/language.ts");



let FullLanguagePipe = class FullLanguagePipe {
    transform(iso) {
        const fullLang = _service_language__WEBPACK_IMPORTED_MODULE_2__["languages"].find(lang => lang.iso_639_1 === iso);
        if (fullLang) {
            return fullLang.english_name;
        }
        return iso;
    }
};
FullLanguagePipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'fullLanguage'
    })
], FullLanguagePipe);



/***/ }),

/***/ "./src/app/pipe/number-with-commas.pipe.ts":
/*!*************************************************!*\
  !*** ./src/app/pipe/number-with-commas.pipe.ts ***!
  \*************************************************/
/*! exports provided: NumberWithCommasPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NumberWithCommasPipe", function() { return NumberWithCommasPipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let NumberWithCommasPipe = class NumberWithCommasPipe {
    transform(number) {
        if (number) {
            return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        }
    }
};
NumberWithCommasPipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'numberWithCommas'
    })
], NumberWithCommasPipe);



/***/ }),

/***/ "./src/app/pipe/number-with-double-digits.pipe.ts":
/*!********************************************************!*\
  !*** ./src/app/pipe/number-with-double-digits.pipe.ts ***!
  \********************************************************/
/*! exports provided: NumberWithDoubleDigitsPipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NumberWithDoubleDigitsPipe", function() { return NumberWithDoubleDigitsPipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let NumberWithDoubleDigitsPipe = class NumberWithDoubleDigitsPipe {
    transform(number) {
        if (number < 10) {
            return `0${number}`;
        }
        return number;
    }
};
NumberWithDoubleDigitsPipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'numberWithDoubleDigits'
    })
], NumberWithDoubleDigitsPipe);



/***/ }),

/***/ "./src/app/pipe/pipe.module.ts":
/*!*************************************!*\
  !*** ./src/app/pipe/pipe.module.ts ***!
  \*************************************/
/*! exports provided: PipeModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PipeModule", function() { return PipeModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _elipsis_pipe__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./elipsis.pipe */ "./src/app/pipe/elipsis.pipe.ts");
/* harmony import */ var _time_pipe__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./time.pipe */ "./src/app/pipe/time.pipe.ts");
/* harmony import */ var _date_pipe__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./date.pipe */ "./src/app/pipe/date.pipe.ts");
/* harmony import */ var _number_with_commas_pipe__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./number-with-commas.pipe */ "./src/app/pipe/number-with-commas.pipe.ts");
/* harmony import */ var _character_with_commas_pipe__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./character-with-commas.pipe */ "./src/app/pipe/character-with-commas.pipe.ts");
/* harmony import */ var _number_with_double_digits_pipe__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./number-with-double-digits.pipe */ "./src/app/pipe/number-with-double-digits.pipe.ts");
/* harmony import */ var _full_language_pipe__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./full-language.pipe */ "./src/app/pipe/full-language.pipe.ts");










let PipeModule = class PipeModule {
};
PipeModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        declarations: [
            _elipsis_pipe__WEBPACK_IMPORTED_MODULE_3__["ElipsisPipe"],
            _time_pipe__WEBPACK_IMPORTED_MODULE_4__["TimePipe"],
            _date_pipe__WEBPACK_IMPORTED_MODULE_5__["DatePipe"],
            _number_with_commas_pipe__WEBPACK_IMPORTED_MODULE_6__["NumberWithCommasPipe"],
            _character_with_commas_pipe__WEBPACK_IMPORTED_MODULE_7__["CharacterWithCommasPipe"],
            _number_with_double_digits_pipe__WEBPACK_IMPORTED_MODULE_8__["NumberWithDoubleDigitsPipe"],
            _full_language_pipe__WEBPACK_IMPORTED_MODULE_9__["FullLanguagePipe"]
        ],
        exports: [
            _elipsis_pipe__WEBPACK_IMPORTED_MODULE_3__["ElipsisPipe"],
            _time_pipe__WEBPACK_IMPORTED_MODULE_4__["TimePipe"],
            _date_pipe__WEBPACK_IMPORTED_MODULE_5__["DatePipe"],
            _number_with_commas_pipe__WEBPACK_IMPORTED_MODULE_6__["NumberWithCommasPipe"],
            _character_with_commas_pipe__WEBPACK_IMPORTED_MODULE_7__["CharacterWithCommasPipe"],
            _number_with_double_digits_pipe__WEBPACK_IMPORTED_MODULE_8__["NumberWithDoubleDigitsPipe"],
            _full_language_pipe__WEBPACK_IMPORTED_MODULE_9__["FullLanguagePipe"]
        ],
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"]
        ]
    })
], PipeModule);



/***/ }),

/***/ "./src/app/pipe/time.pipe.ts":
/*!***********************************!*\
  !*** ./src/app/pipe/time.pipe.ts ***!
  \***********************************/
/*! exports provided: TimePipe */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TimePipe", function() { return TimePipe; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let TimePipe = class TimePipe {
    transform(minutes) {
        // seconds
        const seconds = minutes * 60;
        let secondsLeft = seconds;
        // hours
        const hours = Math.floor(secondsLeft / 3600);
        secondsLeft = secondsLeft % 3600;
        // mins
        const mins = Math.floor(secondsLeft / 60);
        secondsLeft = secondsLeft % 60;
        return `${hours ? hours + 'h' : ''} ${mins}min`;
    }
};
TimePipe = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Pipe"])({
        name: 'time'
    })
], TimePipe);



/***/ }),

/***/ "./src/app/service/language.ts":
/*!*************************************!*\
  !*** ./src/app/service/language.ts ***!
  \*************************************/
/*! exports provided: languages */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "languages", function() { return languages; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");

const languages = [
    { 'iso_639_1': 'xx', 'english_name': 'No Language' },
    { 'iso_639_1': 'aa', 'english_name': 'Afar' },
    { 'iso_639_1': 'af', 'english_name': 'Afrikaans' },
    { 'iso_639_1': 'ak', 'english_name': 'Akan' },
    { 'iso_639_1': 'an', 'english_name': 'Aragonese' },
    { 'iso_639_1': 'as', 'english_name': 'Assamese' },
    { 'iso_639_1': 'av', 'english_name': 'Avaric' },
    { 'iso_639_1': 'ae', 'english_name': 'Avestan' },
    { 'iso_639_1': 'ay', 'english_name': 'Aymara' },
    { 'iso_639_1': 'az', 'english_name': 'Azerbaijani' },
    { 'iso_639_1': 'ba', 'english_name': 'Bashkir' },
    { 'iso_639_1': 'bm', 'english_name': 'Bambara' },
    { 'iso_639_1': 'bi', 'english_name': 'Bislama' },
    { 'iso_639_1': 'bo', 'english_name': 'Tibetan' },
    { 'iso_639_1': 'br', 'english_name': 'Breton' },
    { 'iso_639_1': 'ca', 'english_name': 'Catalan' },
    { 'iso_639_1': 'cs', 'english_name': 'Czech' },
    { 'iso_639_1': 'ce', 'english_name': 'Chechen' },
    { 'iso_639_1': 'cu', 'english_name': 'Slavic' },
    { 'iso_639_1': 'cv', 'english_name': 'Chuvash' },
    { 'iso_639_1': 'kw', 'english_name': 'Cornish' },
    { 'iso_639_1': 'co', 'english_name': 'Corsican' },
    { 'iso_639_1': 'cr', 'english_name': 'Cree' },
    { 'iso_639_1': 'cy', 'english_name': 'Welsh' },
    { 'iso_639_1': 'da', 'english_name': 'Danish' },
    { 'iso_639_1': 'de', 'english_name': 'German' },
    { 'iso_639_1': 'dv', 'english_name': 'Divehi' },
    { 'iso_639_1': 'dz', 'english_name': 'Dzongkha' },
    { 'iso_639_1': 'eo', 'english_name': 'Esperanto' },
    { 'iso_639_1': 'et', 'english_name': 'Estonian' },
    { 'iso_639_1': 'eu', 'english_name': 'Basque' },
    { 'iso_639_1': 'fo', 'english_name': 'Faroese' },
    { 'iso_639_1': 'fj', 'english_name': 'Fijian' },
    { 'iso_639_1': 'fi', 'english_name': 'Finnish' },
    { 'iso_639_1': 'fr', 'english_name': 'French' },
    { 'iso_639_1': 'fy', 'english_name': 'Frisian' },
    { 'iso_639_1': 'ff', 'english_name': 'Fulah' },
    { 'iso_639_1': 'gd', 'english_name': 'Gaelic' },
    { 'iso_639_1': 'ga', 'english_name': 'Irish' },
    { 'iso_639_1': 'gl', 'english_name': 'Galician' },
    { 'iso_639_1': 'gv', 'english_name': 'Manx' },
    { 'iso_639_1': 'gn', 'english_name': 'Guarani' },
    { 'iso_639_1': 'gu', 'english_name': 'Gujarati' },
    { 'iso_639_1': 'ht', 'english_name': 'Haitian; Haitian Creole' },
    { 'iso_639_1': 'ha', 'english_name': 'Hausa' },
    { 'iso_639_1': 'sh', 'english_name': 'Serbo-Croatian' },
    { 'iso_639_1': 'hz', 'english_name': 'Herero' },
    { 'iso_639_1': 'ho', 'english_name': 'Hiri Motu' },
    { 'iso_639_1': 'hr', 'english_name': 'Croatian' },
    { 'iso_639_1': 'hu', 'english_name': 'Hungarian' },
    { 'iso_639_1': 'ig', 'english_name': 'Igbo' },
    { 'iso_639_1': 'io', 'english_name': 'Ido' },
    { 'iso_639_1': 'ii', 'english_name': 'Yi' },
    { 'iso_639_1': 'iu', 'english_name': 'Inuktitut' },
    { 'iso_639_1': 'ie', 'english_name': 'Interlingue' },
    { 'iso_639_1': 'ia', 'english_name': 'Interlingua' },
    { 'iso_639_1': 'id', 'english_name': 'Indonesian' },
    { 'iso_639_1': 'ik', 'english_name': 'Inupiaq' },
    { 'iso_639_1': 'is', 'english_name': 'Icelandic' },
    { 'iso_639_1': 'it', 'english_name': 'Italian' },
    { 'iso_639_1': 'jv', 'english_name': 'Javanese' },
    { 'iso_639_1': 'ja', 'english_name': 'Japanese' },
    { 'iso_639_1': 'kl', 'english_name': 'Kalaallisut' },
    { 'iso_639_1': 'kn', 'english_name': 'Kannada' },
    { 'iso_639_1': 'ks', 'english_name': 'Kashmiri' },
    { 'iso_639_1': 'kr', 'english_name': 'Kanuri' },
    { 'iso_639_1': 'kk', 'english_name': 'Kazakh' },
    { 'iso_639_1': 'km', 'english_name': 'Khmer' },
    { 'iso_639_1': 'ki', 'english_name': 'Kikuyu' },
    { 'iso_639_1': 'rw', 'english_name': 'Kinyarwanda' },
    { 'iso_639_1': 'ky', 'english_name': 'Kirghiz' },
    { 'iso_639_1': 'kv', 'english_name': 'Komi' },
    { 'iso_639_1': 'kg', 'english_name': 'Kongo' },
    { 'iso_639_1': 'ko', 'english_name': 'Korean' },
    { 'iso_639_1': 'kj', 'english_name': 'Kuanyama' },
    { 'iso_639_1': 'ku', 'english_name': 'Kurdish' },
    { 'iso_639_1': 'lo', 'english_name': 'Lao' },
    { 'iso_639_1': 'la', 'english_name': 'Latin' },
    { 'iso_639_1': 'lv', 'english_name': 'Latvian' },
    { 'iso_639_1': 'li', 'english_name': 'Limburgish' },
    { 'iso_639_1': 'ln', 'english_name': 'Lingala' },
    { 'iso_639_1': 'lt', 'english_name': 'Lithuanian' },
    { 'iso_639_1': 'lb', 'english_name': 'Letzeburgesch' },
    { 'iso_639_1': 'lu', 'english_name': 'Luba-Katanga' },
    { 'iso_639_1': 'lg', 'english_name': 'Ganda' },
    { 'iso_639_1': 'mh', 'english_name': 'Marshall' },
    { 'iso_639_1': 'ml', 'english_name': 'Malayalam' },
    { 'iso_639_1': 'mr', 'english_name': 'Marathi' },
    { 'iso_639_1': 'mg', 'english_name': 'Malagasy' },
    { 'iso_639_1': 'mt', 'english_name': 'Maltese' },
    { 'iso_639_1': 'mo', 'english_name': 'Moldavian' },
    { 'iso_639_1': 'mn', 'english_name': 'Mongolian' },
    { 'iso_639_1': 'mi', 'english_name': 'Maori' },
    { 'iso_639_1': 'ms', 'english_name': 'Malay' },
    { 'iso_639_1': 'my', 'english_name': 'Burmese' },
    { 'iso_639_1': 'na', 'english_name': 'Nauru' },
    { 'iso_639_1': 'nv', 'english_name': 'Navajo' },
    { 'iso_639_1': 'nr', 'english_name': 'Ndebele' },
    { 'iso_639_1': 'nd', 'english_name': 'Ndebele' },
    { 'iso_639_1': 'ng', 'english_name': 'Ndonga' },
    { 'iso_639_1': 'ne', 'english_name': 'Nepali' },
    { 'iso_639_1': 'nl', 'english_name': 'Dutch' },
    { 'iso_639_1': 'nn', 'english_name': 'Norwegian Nynorsk' },
    { 'iso_639_1': 'nb', 'english_name': 'Norwegian Bokmål' },
    { 'iso_639_1': 'no', 'english_name': 'Norwegian' },
    { 'iso_639_1': 'ny', 'english_name': 'Chichewa; Nyanja' },
    { 'iso_639_1': 'oc', 'english_name': 'Occitan' },
    { 'iso_639_1': 'oj', 'english_name': 'Ojibwa' },
    { 'iso_639_1': 'or', 'english_name': 'Oriya' },
    { 'iso_639_1': 'om', 'english_name': 'Oromo' },
    { 'iso_639_1': 'os', 'english_name': 'Ossetian; Ossetic' },
    { 'iso_639_1': 'pi', 'english_name': 'Pali' },
    { 'iso_639_1': 'pl', 'english_name': 'Polish' },
    { 'iso_639_1': 'pt', 'english_name': 'Portuguese' },
    { 'iso_639_1': 'qu', 'english_name': 'Quechua' },
    { 'iso_639_1': 'rm', 'english_name': 'Raeto-Romance' },
    { 'iso_639_1': 'ro', 'english_name': 'Romanian' },
    { 'iso_639_1': 'rn', 'english_name': 'Rundi' },
    { 'iso_639_1': 'ru', 'english_name': 'Russian' },
    { 'iso_639_1': 'sg', 'english_name': 'Sango' },
    { 'iso_639_1': 'sa', 'english_name': 'Sanskrit' },
    { 'iso_639_1': 'si', 'english_name': 'Sinhalese' },
    { 'iso_639_1': 'sk', 'english_name': 'Slovak' },
    { 'iso_639_1': 'sl', 'english_name': 'Slovenian' },
    { 'iso_639_1': 'se', 'english_name': 'Northern Sami' },
    { 'iso_639_1': 'sm', 'english_name': 'Samoan' },
    { 'iso_639_1': 'sn', 'english_name': 'Shona' },
    { 'iso_639_1': 'sd', 'english_name': 'Sindhi' },
    { 'iso_639_1': 'so', 'english_name': 'Somali' },
    { 'iso_639_1': 'st', 'english_name': 'Sotho' },
    { 'iso_639_1': 'es', 'english_name': 'Spanish' },
    { 'iso_639_1': 'sq', 'english_name': 'Albanian' },
    { 'iso_639_1': 'sc', 'english_name': 'Sardinian' },
    { 'iso_639_1': 'sr', 'english_name': 'Serbian' },
    { 'iso_639_1': 'ss', 'english_name': 'Swati' },
    { 'iso_639_1': 'su', 'english_name': 'Sundanese' },
    { 'iso_639_1': 'sw', 'english_name': 'Swahili' },
    { 'iso_639_1': 'sv', 'english_name': 'Swedish' },
    { 'iso_639_1': 'ty', 'english_name': 'Tahitian' },
    { 'iso_639_1': 'ta', 'english_name': 'Tamil' },
    { 'iso_639_1': 'tt', 'english_name': 'Tatar' },
    { 'iso_639_1': 'te', 'english_name': 'Telugu' },
    { 'iso_639_1': 'tg', 'english_name': 'Tajik' },
    { 'iso_639_1': 'tl', 'english_name': 'Tagalog' },
    { 'iso_639_1': 'th', 'english_name': 'Thai' },
    { 'iso_639_1': 'ti', 'english_name': 'Tigrinya' },
    { 'iso_639_1': 'to', 'english_name': 'Tonga' },
    { 'iso_639_1': 'tn', 'english_name': 'Tswana' },
    { 'iso_639_1': 'ts', 'english_name': 'Tsonga' },
    { 'iso_639_1': 'tk', 'english_name': 'Turkmen' },
    { 'iso_639_1': 'tr', 'english_name': 'Turkish' },
    { 'iso_639_1': 'tw', 'english_name': 'Twi' },
    { 'iso_639_1': 'ug', 'english_name': 'Uighur' },
    { 'iso_639_1': 'uk', 'english_name': 'Ukrainian' },
    { 'iso_639_1': 'ur', 'english_name': 'Urdu' },
    { 'iso_639_1': 'uz', 'english_name': 'Uzbek' },
    { 'iso_639_1': 've', 'english_name': 'Venda' },
    { 'iso_639_1': 'vi', 'english_name': 'Vietnamese' },
    { 'iso_639_1': 'vo', 'english_name': 'Volapük' },
    { 'iso_639_1': 'wa', 'english_name': 'Walloon' },
    { 'iso_639_1': 'wo', 'english_name': 'Wolof' },
    { 'iso_639_1': 'xh', 'english_name': 'Xhosa' },
    { 'iso_639_1': 'yi', 'english_name': 'Yiddish' },
    { 'iso_639_1': 'za', 'english_name': 'Zhuang' },
    { 'iso_639_1': 'zu', 'english_name': 'Zulu' },
    { 'iso_639_1': 'ab', 'english_name': 'Abkhazian' },
    { 'iso_639_1': 'zh', 'english_name': 'Mandarin' },
    { 'iso_639_1': 'ps', 'english_name': 'Pushto' },
    { 'iso_639_1': 'am', 'english_name': 'Amharic' },
    { 'iso_639_1': 'ar', 'english_name': 'Arabic' },
    { 'iso_639_1': 'bg', 'english_name': 'Bulgarian' },
    { 'iso_639_1': 'cn', 'english_name': 'Cantonese' },
    { 'iso_639_1': 'mk', 'english_name': 'Macedonian' },
    { 'iso_639_1': 'el', 'english_name': 'Greek' },
    { 'iso_639_1': 'fa', 'english_name': 'Persian' },
    { 'iso_639_1': 'he', 'english_name': 'Hebrew' },
    { 'iso_639_1': 'hi', 'english_name': 'Hindi' },
    { 'iso_639_1': 'hy', 'english_name': 'Armenian' },
    { 'iso_639_1': 'en', 'english_name': 'English' },
    { 'iso_639_1': 'ee', 'english_name': 'Ewe' },
    { 'iso_639_1': 'ka', 'english_name': 'Georgian' },
    { 'iso_639_1': 'pa', 'english_name': 'Punjabi' },
    { 'iso_639_1': 'bn', 'english_name': 'Bengali' },
    { 'iso_639_1': 'bs', 'english_name': 'Bosnian' },
    { 'iso_639_1': 'ch', 'english_name': 'Chamorro' },
    { 'iso_639_1': 'be', 'english_name': 'Belarusian' },
    { 'iso_639_1': 'yo', 'english_name': 'Yoruba' },
];


/***/ }),

/***/ "./src/app/service/movies.service.ts":
/*!*******************************************!*\
  !*** ./src/app/service/movies.service.ts ***!
  \*******************************************/
/*! exports provided: MoviesService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MoviesService", function() { return MoviesService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");



let MoviesService = class MoviesService {
    constructor(http) {
        this.http = http;
        this.baseUrl = 'https://api.themoviedb.org/3/';
        this.apiKey = 'dd4d819639705d332d531217b4f7c6b6';
        this.language = 'en-US';
        this.region = 'US';
    }
    getNowPlaying(page) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${this.baseUrl}movie/now_playing?api_key=${this.apiKey}&page=${page}&language=${this.language}&region=${this.region}`);
    }
    searchMovies(searchStr) {
        return this.http.get(`${this.baseUrl}search/movie?api_key=${this.apiKey}&query=${searchStr}`);
    }
    getPopular(page) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${this.baseUrl}movie/popular?api_key=${this.apiKey}&page=${page}&language=${this.language}&region=${this.region}`);
    }
    getUpComingMovies(page) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${this.baseUrl}movie/upcoming?api_key=${this.apiKey}&page=${page}&language=${this.language}&region=${this.region}`);
    }
    getTopRatedMovies(page) {
        // tslint:disable-next-line: max-line-length
        return this.http.get(`${this.baseUrl}movie/top_rated?api_key=${this.apiKey}&page=${page}&language=${this.language}&region=${this.region}`);
    }
    getDiscoverMovies() {
        return this.http.get(`${this.baseUrl}discover/movie?api_key=${this.apiKey}`);
    }
    getGenres() {
        return this.http.get(`${this.baseUrl}genre/movie/list?api_key=${this.apiKey}&language=${this.language}`);
    }
    getMoviesByGenre(id) {
        return this.http.get(`${this.baseUrl}genre/${id}/movies?api_key=${this.apiKey}`);
    }
    getMovie(id) {
        return this.http.get(`${this.baseUrl}movie/${id}?api_key=${this.apiKey}`);
    }
    getMovieReviews(id) {
        return this.http.get(`${this.baseUrl}movie/${id}/reviews?api_key=${this.apiKey}`);
    }
    getMovieCredits(id) {
        return this.http.get(`${this.baseUrl}movie/${id}/credits?api_key=${this.apiKey}`);
    }
    getBackdropsImages(id) {
        return this.http.get(`${this.baseUrl}movie/${id}/images?api_key=${this.apiKey}`);
    }
    getMovieVideos(id) {
        return this.http.get(`${this.baseUrl}movie/${id}/videos?api_key=${this.apiKey}`);
    }
    getRecomendMovies(id) {
        return this.http.get(`${this.baseUrl}movie/${id}/recommendations?api_key=${this.apiKey}`);
    }
    getPersonDetail(id) {
        return this.http.get(`${this.baseUrl}person/${id}?api_key=${this.apiKey}`);
    }
    getPersonExternalData(id) {
        return this.http.get(`${this.baseUrl}person/${id}/external_ids?api_key=${this.apiKey}`);
    }
    getPersonCast(id) {
        return this.http.get(`${this.baseUrl}person/${id}/movie_credits?api_key=${this.apiKey}`);
    }
};
MoviesService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
MoviesService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], MoviesService);



/***/ }),

/***/ "./src/app/service/tv.service.ts":
/*!***************************************!*\
  !*** ./src/app/service/tv.service.ts ***!
  \***************************************/
/*! exports provided: TvService */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TvService", function() { return TvService; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common_http__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common/http */ "./node_modules/@angular/common/fesm2015/http.js");



let TvService = class TvService {
    constructor(http) {
        this.http = http;
        this.baseUrl = 'https://api.themoviedb.org/3/';
        this.apiKey = 'dd4d819639705d332d531217b4f7c6b6';
        this.language = 'en-US';
        this.region = 'US';
    }
    getTvOnTheAir(page) {
        return this.http.get(`${this.baseUrl}tv/on_the_air?api_key=${this.apiKey}&page=${page}&language=${this.language}`);
    }
    getTVAiringToday(page) {
        return this.http.get(`${this.baseUrl}tv/airing_today?api_key=${this.apiKey}&page=${page}&language=${this.language}`);
    }
    getPopularTVShow(page) {
        return this.http.get(`${this.baseUrl}tv/popular?api_key=${this.apiKey}&page=${page}&language=${this.language}`);
    }
    getTopRatedTVShows(page) {
        return this.http.get(`${this.baseUrl}tv/top_rated?api_key=${this.apiKey}&page=${page}&language=${this.language}`);
    }
    getTVShow(id) {
        return this.http.get(`${this.baseUrl}tv/${id}?api_key=${this.apiKey}&language=${this.language}`);
    }
    getTvVideos(id) {
        return this.http.get(`${this.baseUrl}tv/${id}/videos?api_key=${this.apiKey}&language=${this.language}`);
    }
    getTvBackdropsImages(id) {
        return this.http.get(`${this.baseUrl}tv/${id}/images?api_key=${this.apiKey}`);
    }
    getMovieCredits(id) {
        return this.http.get(`${this.baseUrl}tv/${id}/credits?api_key=${this.apiKey}&language=${this.language}`);
    }
    getGenres() {
        return this.http.get(`${this.baseUrl}genre/tv/list?api_key=${this.apiKey}&language=${this.language}`);
    }
    getTVShowByGenre(id) {
        return this.http.get(`${this.baseUrl}discover/tv?api_key=${this.apiKey}&language=en-US&sort_by=popularity.desc&page=1&timezone=America%2FNew_York&with_genres=${id}&include_null_first_air_dates=false`);
    }
    getRecomendTv(id) {
        return this.http.get(`${this.baseUrl}tv/${id}/recommendations?api_key=${this.apiKey}&language=${this.language}`);
    }
    searchtv(searchStr) {
        return this.http.get(`${this.baseUrl}search/tv?api_key=${this.apiKey}&query=${searchStr}`);
    }
};
TvService.ctorParameters = () => [
    { type: _angular_common_http__WEBPACK_IMPORTED_MODULE_2__["HttpClient"] }
];
TvService = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Injectable"])({
        providedIn: 'root'
    })
], TvService);



/***/ }),

/***/ "./src/app/shared/skeleton/skeleton.component.scss":
/*!*********************************************************!*\
  !*** ./src/app/shared/skeleton/skeleton.component.scss ***!
  \*********************************************************/
/*! exports provided: default */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = (".item-with-background {\n  background: #121212;\n  padding: 10px;\n}\n/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi92ZXJjZWwvcGF0aDAvc3JjL2FwcC9zaGFyZWQvc2tlbGV0b24vc2tlbGV0b24uY29tcG9uZW50LnNjc3MiLCJzcmMvYXBwL3NoYXJlZC9za2VsZXRvbi9za2VsZXRvbi5jb21wb25lbnQuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtFQUNJLG1CQUFBO0VBQ0EsYUFBQTtBQ0NKIiwiZmlsZSI6InNyYy9hcHAvc2hhcmVkL3NrZWxldG9uL3NrZWxldG9uLmNvbXBvbmVudC5zY3NzIiwic291cmNlc0NvbnRlbnQiOlsiLml0ZW0td2l0aC1iYWNrZ3JvdW5kIHtcbiAgICBiYWNrZ3JvdW5kOiAjMTIxMjEyO1xuICAgIHBhZGRpbmc6IDEwcHg7XG4gIH0iLCIuaXRlbS13aXRoLWJhY2tncm91bmQge1xuICBiYWNrZ3JvdW5kOiAjMTIxMjEyO1xuICBwYWRkaW5nOiAxMHB4O1xufSJdfQ== */");

/***/ }),

/***/ "./src/app/shared/skeleton/skeleton.component.ts":
/*!*******************************************************!*\
  !*** ./src/app/shared/skeleton/skeleton.component.ts ***!
  \*******************************************************/
/*! exports provided: SkeletonComponent */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SkeletonComponent", function() { return SkeletonComponent; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");


let SkeletonComponent = class SkeletonComponent {
    constructor() { }
    ngOnInit() {
    }
};
SkeletonComponent = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["Component"])({
        selector: 'app-skeleton',
        template: tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! raw-loader!./skeleton.component.html */ "./node_modules/raw-loader/dist/cjs.js!./src/app/shared/skeleton/skeleton.component.html")).default,
        styles: [tslib__WEBPACK_IMPORTED_MODULE_0__["__importDefault"](__webpack_require__(/*! ./skeleton.component.scss */ "./src/app/shared/skeleton/skeleton.component.scss")).default]
    })
], SkeletonComponent);



/***/ }),

/***/ "./src/app/shared/skeleton/skeleton.module.ts":
/*!****************************************************!*\
  !*** ./src/app/shared/skeleton/skeleton.module.ts ***!
  \****************************************************/
/*! exports provided: SkeletonModule */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SkeletonModule", function() { return SkeletonModule; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/common */ "./node_modules/@angular/common/fesm2015/common.js");
/* harmony import */ var _skeleton_component__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./skeleton.component */ "./src/app/shared/skeleton/skeleton.component.ts");
/* harmony import */ var ngx_skeleton_loader__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ngx-skeleton-loader */ "./node_modules/ngx-skeleton-loader/fesm2015/ngx-skeleton-loader.js");





let SkeletonModule = class SkeletonModule {
};
SkeletonModule = tslib__WEBPACK_IMPORTED_MODULE_0__["__decorate"]([
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_1__["NgModule"])({
        imports: [
            _angular_common__WEBPACK_IMPORTED_MODULE_2__["CommonModule"],
            ngx_skeleton_loader__WEBPACK_IMPORTED_MODULE_4__["NgxSkeletonLoaderModule"]
        ],
        declarations: [_skeleton_component__WEBPACK_IMPORTED_MODULE_3__["SkeletonComponent"]],
        exports: [_skeleton_component__WEBPACK_IMPORTED_MODULE_3__["SkeletonComponent"]]
    })
], SkeletonModule);



/***/ }),

/***/ "./src/environments/environment.ts":
/*!*****************************************!*\
  !*** ./src/environments/environment.ts ***!
  \*****************************************/
/*! exports provided: environment */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "environment", function() { return environment; });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

const environment = {
    production: false
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.


/***/ }),

/***/ "./src/main.ts":
/*!*********************!*\
  !*** ./src/main.ts ***!
  \*********************/
/*! no exports provided */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./node_modules/tslib/tslib.es6.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! hammerjs */ "./node_modules/hammerjs/hammer.js");
/* harmony import */ var hammerjs__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(hammerjs__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _angular_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @angular/core */ "./node_modules/@angular/core/fesm2015/core.js");
/* harmony import */ var _angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! @angular/platform-browser-dynamic */ "./node_modules/@angular/platform-browser-dynamic/fesm2015/platform-browser-dynamic.js");
/* harmony import */ var _app_app_module__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./app/app.module */ "./src/app/app.module.ts");
/* harmony import */ var _environments_environment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./environments/environment */ "./src/environments/environment.ts");






if (_environments_environment__WEBPACK_IMPORTED_MODULE_5__["environment"].production) {
    Object(_angular_core__WEBPACK_IMPORTED_MODULE_2__["enableProdMode"])();
}
Object(_angular_platform_browser_dynamic__WEBPACK_IMPORTED_MODULE_3__["platformBrowserDynamic"])().bootstrapModule(_app_app_module__WEBPACK_IMPORTED_MODULE_4__["AppModule"])
    .catch(err => console.error(err));


/***/ }),

/***/ 0:
/*!***************************!*\
  !*** multi ./src/main.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(/*! /vercel/path0/src/main.ts */"./src/main.ts");


/***/ })

},[[0,"runtime","vendor"]]]);
//# sourceMappingURL=main-es2015.js.map